import { LinearProgress, Typography, Grid, Button } from '@material-ui/core'
import { FC, Fragment } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import {
  reduxForm,
  FieldArray,
  formValueSelector,
  arrayRemoveAll
} from 'redux-form'
import { CloseDialog } from '../../../../actions/types'
import { DialogButtons, SubmitFormButton } from '../../../../components/Buttons'
import ErrorMessage from '../../../../components/Error/ErrorMessage'
import { MuiClasses } from '../../../../types'
import { ReduxForm } from '../../../../types/forms'
import {
  AddShowingsFormData,
  FormShowing
  // ShowingType
} from '../../../../types/showings'
import { StateInterface } from '../../../../types/states'
import ShowingFields from '../ShowingFields'

interface CreateShowingsFormProps extends WithTranslation, ReduxForm {
  createShowingsAction: (formData: AddShowingsFormData) => void
  showings: FormShowing[]
  closeDialog: CloseDialog
  arrayRemoveAllAction: (form: string, field: string) => void
  // showingType: ShowingType
  classes: MuiClasses
  isConfirmDialog?: boolean
  openDialog?: any
}

/** if isConfirmDialog, just show the form submit button */
const CreateShowingsForm: FC<CreateShowingsFormProps> = ({
  handleSubmit,
  submitting,
  error,
  createShowingsAction,
  showings,
  t,
  isConfirmDialog,
  closeDialog,
  arrayRemoveAllAction,
  // showingType,
  classes,
  openDialog
}) => (
  <form
    onSubmit={handleSubmit(createShowingsAction)}
    {...(!isConfirmDialog && { className: classes.createShowingsForm })}
  >
    {!isConfirmDialog && showings?.length > 0 && openDialog && (
      <Grid container direction='column' justify='space-between'>
        <Grid
          item
          container
          direction='row'
          justify='space-between'
          style={{ paddingTop: '65px' }}
        >
          <Grid item xs={5} sm='auto' style={{ marginLeft: '6px' }}>
            <Typography variant='h5'>{t('showings.list.new')}</Typography>
          </Grid>
          <Grid item xs={6} sm='auto' style={{ alignSelf: 'flex-end' }}>
            <Button
              onClick={() =>
                arrayRemoveAllAction('CreateShowingsForm', 'showings')
              }
              type='submit'
              variant='contained'
              color='secondary'
            >
              {t('general.deleteCustom', { message: t('general.newPlural') })}
            </Button>
          </Grid>
        </Grid>
        <FieldArray
          name='showings'
          component={ShowingFields}
          t={t}
          // showingType={showingType}
        />
      </Grid>
    )}
    {isConfirmDialog && (
      <Fragment>
        <ErrorMessage error={error} />
        {submitting && <LinearProgress />}
        <DialogButtons
          closeDialog={closeDialog}
          dialogName='ShowingsConfirmationDialog'
          ButtonTwo={
            <SubmitFormButton
              textColor='white'
              variant='contained'
              submitting={submitting}
              label='application.inviteApplicants'
            />
          }
        />
      </Fragment>
    )}
  </form>
)
const selector = formValueSelector('CreateShowingsForm')

const mapStateToProps = (state: StateInterface) => ({
  showings: selector(state, 'showings')
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  arrayRemoveAllAction: (form: string, field: string) =>
    dispatch(arrayRemoveAll(form, field))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'CreateShowingsForm',
    keepDirtyOnReinitialize: true,
    destroyOnUnmount: false
  })(withTranslation()(CreateShowingsForm) as any) as any
) as any
